import { createAction, props, union } from '@ngrx/store';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';

export const updateTemporaryEuropeanCover = createAction(
  '[YourTemporaryEuropeanCovers] Update Temporary European Cover',
  props<{ updatedTemporaryEuropeanCover: any}>()
);

export const resetError = createAction(
  '[YourTemporaryEuropeanCover] Reset Error'
);

export const setupNavigation = createAction(
  '[YourTemporaryEuropeanCoverNavigation] Set Navigation',
  props<{ navCommands: KeyValueDict<string>}>()
);

const all = union({updateTemporaryEuropeanCover, resetError});
export type YourTemporaryEuropeanCoverActionsUnion = typeof all;
